Storage = require 'lib/storage'
_ = require 'underscore'

STORAGE_KEY = 'error_history'
module.exports =
  add: (entry) ->
    errors = @recent()
    errors.unshift(entry)
    errors = _.first(errors, 5)
    Storage.set(STORAGE_KEY, errors)

  recent: ->
    Storage.get(STORAGE_KEY) ? []



// WEBPACK FOOTER //
// ./app/scripts/debug/error-memory.coffee